import { useMemo } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { computeTimeBuckets } from "./formatters";
import { LogEntry } from "./types";
import { tokens, SEVERITY } from "./tokens";

interface ErrorTimeChartProps {
  logs: LogEntry[];
  bucketMinutes: number;
  /** Bar fill color (defaults to the error severity tint). Lets callers tint per severity. */
  color?: string;
}

export default function ErrorTimeChart({
  logs,
  bucketMinutes,
  color = SEVERITY.error.text,
}: ErrorTimeChartProps) {
  const chartData = useMemo(
    () => computeTimeBuckets(logs, bucketMinutes),
    [logs, bucketMinutes]
  );

  if (!chartData.length) return null;

  return (
    <ResponsiveContainer width="100%" height={140}>
      <BarChart data={chartData} margin={{ top: 4, right: 4, bottom: 0, left: -20 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={tokens.divider} vertical={false} />
        <XAxis
          dataKey="time"
          tick={{ fontSize: 10, fill: tokens.textSecondary }}
          tickLine={false}
          axisLine={{ stroke: tokens.divider }}
        />
        <YAxis
          allowDecimals={false}
          tick={{ fontSize: 10, fill: tokens.textSecondary }}
          tickLine={false}
          axisLine={false}
        />
        <Tooltip
          contentStyle={{
            fontSize: "0.72rem",
            border: `1px solid ${tokens.divider}`,
            borderRadius: 4,
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
          labelStyle={{ fontWeight: 600, color: tokens.textPrimary }}
        />
        <Bar dataKey="count" fill={color} radius={[2, 2, 0, 0]} maxBarSize={32} />
      </BarChart>
    </ResponsiveContainer>
  );
}
